import React from 'react';
import parse, { DOMNode, domToReact, Element } from 'html-react-parser';
import Link from '@amzn/meridian/link';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import DOMPurify from 'dompurify';
import Alert from '@amzn/meridian/alert';
import { FormattedMessage } from 'react-intl';
import { logger } from '../../Util';

interface HtmlToMeridianProps {
  html: string;
}

const HtmlToMeridian: React.FC<HtmlToMeridianProps> = ({ html }) => {
  try {
    return (
      <>
        {parse(DOMPurify.sanitize(html), {
          replace(domNode) {
            if (domNode.type !== 'tag') return;

            const node = domNode as Element;

            switch (node.tagName) {
              case 'a':
                return (
                  <Link {...node.attribs}>
                    {domToReact(node.children as DOMNode[])}
                  </Link>
                );
              case 'h1':
                return (
                  <Heading level={1} type='h400'>
                    {domToReact(node.children as DOMNode[])}
                  </Heading>
                );
              case 'h2':
                return (
                  <Heading level={2} type='h300'>
                    {domToReact(node.children as DOMNode[])}
                  </Heading>
                );
              case 'h3':
                return (
                  <Heading level={3} type='h200'>
                    {domToReact(node.children as DOMNode[])}
                  </Heading>
                );
              case 'h4':
                return (
                  <Heading level={4} type='h100'>
                    {domToReact(node.children as DOMNode[])}
                  </Heading>
                );
              case 'p':
                return (
                  <Text type='b300'>
                    {domToReact(node.children as DOMNode[])}
                  </Text>
                );
              case 'ul':
                return (
                  <Text tag='ul'>{domToReact(node.children as DOMNode[])}</Text>
                );
              case 'ol':
                return (
                  <Text tag='ol'>{domToReact(node.children as DOMNode[])}</Text>
                );
              default:
                return;
            }
          },
        })}
      </>
    );
  } catch (e) {
    logger.error(
      'Error converting ResourceHub html content to Meridian components',
      e as Error
    );
    return (
      <Alert type='error'>
        <FormattedMessage
          id='cs_perfportal_error_refresh_page'
          defaultMessage='Something went wrong. Please try refreshing the page. If the problem persists, please submit a SIM ticket for us to troubleshoot.'
        />
      </Alert>
    );
  }
};

export default HtmlToMeridian;
